import React from "react";
import { Link } from 'react-router'

function Meeting() {
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
                <div className="title_member">
                    <h4>Edit Meeting</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>Edit Meeting</span>
                    </nav>
                </div>

                <div className="page-title fw-semibold fs-18 mb-0">
                    <Link to="/meeting-list" className="add-btn">
                        Meeting List
                    </Link>
                </div>
            </div>
               <div className="main_page">
                <div className="card">
                    <div className="card-body">
            <form>
                    <div className="form_all">
                              <div className="container">
                    <div className="row">

                        {/* Meeting Title */}
                        <div className="col-md-6 mb-3">
                            <label>
                                Meeting Title <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control custumform"
                                placeholder="Enter Meeting Title"
                            />
                        </div>

                        {/* Client Name */}
                        <div className="col-md-6 mb-3">
                            <label>
                                Client Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control custumform"
                                placeholder="Enter Client Name"
                            />
                        </div>

                        {/* Project Name */}
                        <div className="col-md-6 mb-3">
                            <label>Project Name</label>
                            <input
                                type="text"
                                className="form-control custumform"
                                placeholder="Enter Project Name"
                            />
                        </div>

                        {/* Meeting Person */}
                        <div className="col-md-6 mb-3">
                            <label>Meeting Person</label>
                            <select className="form-control custumform">
                                <option>Select Employee</option>
                                <option>Rahul Sharma</option>
                                <option>Rohit Kumar</option>
                                <option>Deepak Verma</option>
                                <option>Amit Kumar</option>
                            </select>
                        </div>

                        {/* Meeting Date */}
                        <div className="col-md-6 mb-3">
                            <label>
                                Meeting Date <span className="text-danger">*</span>
                            </label>
                            <input
                                type="date"
                                className="form-control custumform"
                            />
                        </div>

                        {/* Meeting Time */}
                        <div className="col-md-6 mb-3">
                            <label>
                                Meeting Time <span className="text-danger">*</span>
                            </label>
                            <input
                                type="time"
                                className="form-control custumform"
                            />
                        </div>

                        {/* Meeting Type */}
                        <div className="col-md-6 mb-3">
                            <label>Meeting Type</label>
                            <select className="form-control custumform">
                                <option>Online</option>
                                <option>Offline</option>
                                <option>Video Call</option>
                                <option>Phone Call</option>
                            </select>
                        </div>

                        {/* Meeting Status */}
                        <div className="col-md-6 mb-3">
                            <label>Status</label>
                            <select className="form-control custumform">
                                <option>Scheduled</option>
                                <option>Completed</option>
                                <option>Cancelled</option>
                                <option>Postponed</option>
                            </select>
                        </div>

                        {/* Location */}
                        <div className="col-md-6 mb-3">
                            <label>Meeting Location</label>
                            <input
                                type="text"
                                className="form-control custumform"
                                placeholder="Office / Google Meet Link"
                            />
                        </div>

                        {/* Duration */}
                        <div className="col-md-6 mb-3">
                            <label>Duration</label>
                            <select className="form-control custumform">
                                <option>15 Minutes</option>
                                <option>30 Minutes</option>
                                <option>45 Minutes</option>
                                <option>1 Hour</option>
                                <option>2 Hours</option>
                            </select>
                        </div>

                        {/* Agenda */}
                        <div className="col-md-12 mb-3">
                            <label>Meeting Agenda</label>
                            <textarea
                                className="form-control custumform"
                                rows="4"
                                placeholder="Enter Meeting Agenda..."
                            ></textarea>
                        </div>

                        {/* Submit */}
                        <div className="col-md-12">
                            <div className="d-flex justify-content-end">
                                <div className="button_submit">
                                    <button
                                        type="submit"
                                        className="total_btn"
                                    >
                                        Save Meeting
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                    </div>
            </form>
            </div>
            </div>
            </div>
        </>
    );
}

export default Meeting;